
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6D7587","fill-rule":"evenodd","d":"M16.804 2.647H9.746L8.469.976C8.169.378 7.559 0 6.89 0H1.804a.88.88 0 00-.882.882v12.353c0 .975.79 1.765 1.765 1.765h14.117c.974 0 1.765-.79 1.765-1.765V4.412c0-.974-.79-1.765-1.765-1.765"}})])
          )
        }
      }
    